import React, { useEffect } from 'react'
import { SunlightTab as SunlightTabUI } from '../../../SunlightTab'
import { useAnalysisMode } from '../../contexts/AnalysisModeContext'
import { useAnalysisServices } from '../../contexts/AnalysisServicesContext'
import { useAnalysisMapSectionData } from '../../contexts/MapSectionDataContext'

export const AnalysisSunlightTab: React.FC = () => {
  const { entity } = useAnalysisMode()
  const { getSectionData } = useAnalysisServices()
  const { setActiveSection } = useAnalysisMapSectionData()

  useEffect(() => {
    setActiveSection('sunlight_study')
  }, [setActiveSection])

  const sunlightData = getSectionData('sunlight') || entity?.sunlight || null

  return <SunlightTabUI data={sunlightData} />
}
